import { render, staticRenderFns } from "./AddCostOriginValue.vue?vue&type=template&id=1514fc4d&scoped=true&"
import script from "./AddCostOriginValue.vue?vue&type=script&lang=js&"
export * from "./AddCostOriginValue.vue?vue&type=script&lang=js&"
import style0 from "./AddCostOriginValue.vue?vue&type=style&index=0&id=1514fc4d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1514fc4d",
  null
  
)

export default component.exports